import gql from 'graphql-tag';

export default gql`
  mutation createOneUserGroupMutation(
    $type: String!
    $name: String!
    $course: MongoID
    $teacher: MongoID!
    $courseCategory: MongoID
    $users: [MongoID]
  ) {
    createOneUserGroupMutation(
      type: $type
      name: $name
      course: $course
      teacher: $teacher
      courseCategory: $courseCategory
      users: $users
    ) {
      record {
        _id
      }
    }
  }
`;
